import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'sv_SE',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '134488a2-8dca-4249-b8fc-f3c9b4501b1d',
  ''
);
